import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import { InterviewStage } from "@/services/pages/clients/jobs/interview-stages";
import Button from "@/components/button";
import ButtonStyle from '@/styles/components/button/_index.module.scss';
import { JobShareCV } from "@/services/pages/clients/jobs/job-share-cv";
import { CandidateShareCV } from "@/services/pages/clients/candidates/candidate-job-share-cv";
import { CustomToastrAction, toastr } from "@/imports-files/common/common";

class ActionShareCv
{

    constructor( setValue, setSuggestion)
    {
        this.setValue             =   setValue;
        this.setSuggestion        =   setSuggestion;
        this.customToastrAction   =   new CustomToastrAction();
    }

    async getSuggestions({value})
    {
      const escapedValue = this.escapeRegexCharacters(value?.trim());
      if (escapedValue === '') 
      {
         return [];
      }
      const body = {name_or_email: escapedValue};
      const finalUsers = await new InterviewStage().getUserByNameOrEmail(body);
      return finalUsers.data.users;
    }

    escapeRegexCharacters(str) 
    {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    getSuggestionValue = suggestion => suggestion.user_attributes.name || suggestion.user_attributes.email;

    renderSuggestion = suggestion => ( <div> {suggestion.user_attributes.name || suggestion.user_attributes.email}</div> );

    onSuggestionsFetchRequested = async (value) => { 
      var suggestion = await this.getSuggestions(value);
      this.setSuggestion(suggestion);
    }

    onSuggestionsClearRequested = () => { this.setSuggestion([])};
                
    shouldRenderSuggestions(value)
    {
        return value.trim().length >= 3
    }
    
    renderInputComponent(inputProps, selectedToValues =[], setSelectedToValues, setSelectedToUserCount, setToValue)
    { 
      // return(<div className="buttonIn ShareCV">
      return(
        <div className="buttonIn AutoSuggestInput__Tags" style={inputProps.styleError}>
        {inputProps.selectedValues?.map((item, index) => (
          <div className={PageStyle.SetupPopup__Tags} key={index}>
            {item.name ? (<span>{item.name}</span>) : (<span>{item.email}</span>)}
            <button
              type="button"
              className={PageStyle.Tagrow__Cancel}
              onClick={(event) =>
                inputProps.removeSelectedValues(
                  event,
                  inputProps.selectedValues,
                  inputProps.setSelectedValues,
                  inputProps.setSelectedUserCount
                )
              }
              data-index={index}
            >
              {inputProps.closeIcon}
            </button>
          </div>
        ))}

       <input  className   = {PageStyle.Form__Input} autoComplete="password"  {...inputProps} />
        {/*<Button buttonstyle = {`${ButtonStyle.nobgbutton} addbtn`} onClick={(event)=>{this.onAddClick(event, inputProps, selectedToValues, setSelectedToValues, setSelectedToUserCount, setToValue)}}>Add</Button>*/}
    </div>
    )
    };
    
    onAddClick(event, params, selectedToValues, setSelectedToValues, setSelectedToUserCount, setToValue)
    {
      event.preventDefault();
      let email = params.value 
      if(this.isEmail(email))
      {
        email = ((typeof email == 'string') ? {email: email, name: email} : email)
        this.onSuggestionSelectionEmail( email, selectedToValues, setSelectedToValues, setToValue, setSelectedToUserCount, params.formik)
                                      }
      else
      {
        email == '' ? params.formik.setStatus({'email':{'to':'Required'}}): params.formik.setStatus({'email':{'to':'Please enter valid email'}});
        params.formik.setFieldTouched('email.to', true)
       
      }
    }

    removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount)
    {
      var selected_value_index = parseInt(event.currentTarget.getAttribute('data-index'));
      selectedValues.splice(selected_value_index,1);
      setSelectedValues(selectedValues);
      setSelectedUserCount(selectedValues.length)
    }

    onSuggestionSelectionEmail(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    {
      this.add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    }

    onSuggestionSelectionValue(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    {
      this.add_selected_value(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    }

    handleKeyDown(evt, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik)
    {
      if (["Enter"].includes(evt.key)) 
      {
        var k_this = this;
        setTimeout(function() 
        {
          evt.preventDefault();
          let email = evt.target.value;
          if(k_this.isEmail(email))
          {
             k_this.add_selected_value({email:email, name:email}, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik);
          }
        }, 0);
      };
    }

    add_default_selected_value_email(values, selectedValues, setSelectedValues, setValue, setSelectedUserCount)
    {
        var emails = [];

         if(typeof selectedValues == 'undefined')
        {
          selectedValues = []
        }
          for(var element of selectedValues)
          {
            emails.push(element.email);
          }
        
        for(let value of values)
        {
          if(!emails.includes(value.email))
          {
            selectedValues.push(value);
            setValue('');
            setSelectedValues(selectedValues);
            setSelectedUserCount(selectedValues.length);
          }
          else if( emails.includes(value.email) )
          {
            setValue('');
          }
        }
    }

    add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    {
        var emails = [];

        for(var element of selectedValues)
        {
          emails.push(element.email);
        }

        if(!emails.includes(value.email))
        {
          selectedValues.push(value);
          setValue('');
          setSelectedValues(selectedValues);
          setSelectedUserCount(selectedValues.length);
        }
        else if( emails.includes(value.email) )
        {
           setValue('');
        }
        
    }

    add_selected_value(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
    {
        var emails = [];

        for(var element of selectedValues)
        {
          emails.push(element.email);
        }

        if(!emails.includes(value.email))
        {
          selectedValues.push(value);
          setValue('');
          setSelectedValues(selectedValues);
          setSelectedUserCount(selectedValues.length);
        }
        else if( emails.includes(value.email) )
        {
           setValue('');
        }
    }

    isEmail(email) 
    {
      return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
    }

    async submitCandidateShareForm(router, formik, selectedValues, setApiError, setButtonPopup, setSelectedValues, t)
    {
        var emails = this.getEmails(selectedValues);
        if(selectedValues.length > 0)
        { 
          var is_candidate_general_profile    =     router.asPath.includes('/clients/candidates/') &&  router.asPath.includes('/view-profile');
          var entity_id                       =     is_candidate_general_profile ? router.query.candidate_id : router.query.applicant_id;
          var entity_type                     =     is_candidate_general_profile ? 'ClientCandidate' : 'JobApplication';
          var body                            =     { candidate_share : { member_emails: emails, note: formik.values.title_note, entity_id : entity_id, entity_type: entity_type}}
          var result                          =     is_candidate_general_profile  ? await new CandidateShareCV().sendCV(body, entity_id) : new JobShareCV().sendCV(body, entity_id);

          result.request.status != 200 ? setApiError(result.request) 
                                       : setButtonPopup(false);
                                         setSelectedValues([]);
                                        if(result.request.status == 200) {
                                          this.customToastrAction.setNormalToastr(result.data.success, 'success');
                                        }
                                        else{
                                          this.customToastrAction.setNormalToastr(result.response.data.error, 'error');
                                        }
                                        //toastr.success(result.data.success);
        }
        else
        {
          formik.touched['share_with'] = true;
          formik.setStatus({ share_with: t('errors:existing_user_suggestions')});
        }
    }

    async submitJobShareForm(router, formik, selectedValues, setApiError, setButtonPopup, setSelectedValues, t)
    {
        var emails = this.getEmails(selectedValues);
        if(selectedValues.length > 0)
        { 
          var is_candidate_general_profile    =     router.asPath.includes('/clients/candidates/') &&  router.asPath.includes('/view-profile');
          var entity_id                       =     is_candidate_general_profile ? router.query.candidate_id : router.query.applicant_id;
          var entity_type                     =     is_candidate_general_profile ? 'ClientCandidate' : 'JobApplication';
          var body                            =     { candidate_share : { member_emails: emails, note: formik.values.title_note, entity_id : entity_id, entity_type: entity_type}}
          var result                          =     await new JobShareCV().sendCV(body, entity_id);
          
          result.request.status != 200 ? setApiError(result.request) 
                                       : setButtonPopup(false);
                                         setSelectedValues([]);
                                         if(result.request.status == 200) {
                                            this.customToastrAction.setNormalToastr(result.data.success, 'success');
                                          }
                                          else{
                                            this.customToastrAction.setNormalToastr(result.response.data.error, 'error');
                                          }
                                        //  toastr.success(result.data.success);
        }
        else
        {
          formik.touched['share_with'] = true;
          formik.setStatus({ share_with: t('errors:existing_user_suggestions')});
        }
    }

    getEmails(values)
    {
        var emails = []; 
        for(var element of values)
        {
          emails.push(element.email)
        }

        return emails;
    }
}

export {ActionShareCv};